/* eslint-disable import/prefer-default-export */
const isDevelopment = (process.env.REACT_APP_ENV || '').trim() === 'development';

export { isDevelopment };
